import { Button, Form, Input, Table } from "antd";
import { FiEdit } from "react-icons/fi";
import Manage from "..";
import { useEffect, useState } from "react";
import UpdateUser from "./components/UpdateUser";
import DeleteUser from "./components/DeleteUser";
import CreateWrapper from "./components/CreateWrapper";
import UpdateApr from "./components/UpdateApr";
import EditUser from "./components/EditUser";
import UpdateCountry from "./components/UpdateCountry";
import UpdateScope from "./components/UpdateScope";
import UploadWrapper from "./components/UploadWrapper";
import { ColumnsType } from "antd/es/table";
import { RiFilterOffLine } from "react-icons/ri";
import { handleFetchUnlinkedClaimers } from "../../../api/users";
import { useQuery } from "@tanstack/react-query";
import { Signature } from "lucide-react";
import UploadSign from "./components/UploadSign";
import { MdOutlineCheckCircle, MdOutlinePending } from "react-icons/md";
const { Search } = Input;

export default function UnlinkedUsers() {
  const [updateModal, setUpdateModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [countryModal, setCountryModal] = useState(false);
  const [scopeModal, setScopeModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [approverModal, setApproverModal] = useState(false);
  const [selected, setSelected] = useState({});
  const [form] = Form.useForm();

  const initials = {
    name: "",
  };

  const [filters, setFilters] = useState<any>({ ...initials });

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });

  const {
    data: users,
    refetch,
    isLoading,
  } = useQuery({
    queryKey: ["unlinkedclaimers", pagination.page, pagination.limit],
    queryFn: () =>
      handleFetchUnlinkedClaimers({
        page: pagination.page,
        limit: pagination.limit,
      }),
  });

  const handlePageChange = (e: any) => {
    setPagination((prev: any) => ({
      ...prev,
      page: e.current,
      limit: e.pageSize,
    }));
  };

  const clearAllFilters = async () => {
    form.resetFields();
    setFilters({ ...initials });
    handleRefetch();
  };
  const handleRefetch = () => {
    refetch();
  };

  interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
  }

  const columns: ColumnsType<DataType> = [
    {
      title: "S/N",
      width: 50,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">
          {pagination?.page * pagination?.limit - pagination?.limit + index + 1}
        </span>
      ),
      fixed: "left",
    },
    {
      title: "KJL ID",
      width: 80,
      render: (record: any) => (
        <span className="text-gray-700 truncate">{record?.kjlID || ""}</span>
      ),
      fixed: "left",
    },
    {
      title: "STATUS",
      width: 70,
      render: (record: any) => (
        <span className="text-gray-700 truncate">
          {record?.isActive ? (
            <span className="text-green-600">Active</span>
          ) : (
            <span className="text-red-600">Inactive</span>
          )}
        </span>
      ),
      fixed: "left",
    },
    {
      title: "NAME",
      width: 240,
      render: (record: any) => (
        <div className="text-gray-700 truncate">
          {record?.name === null ? "-" : `${record?.name}`}
        </div>
      ),
    },
    {
      title: "EMAIL",
      width: 200,
      render: (record: any) => (
        <div className="text-gray-700 truncate">
          {record?.email === null ? "-" : `${record?.email}`}
        </div>
      ),
    },
    {
      title: "MOBILE",
      width: 150,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.mobile === undefined ? "-" : `${record?.mobile}`}
        </span>
      ),
    },
    {
      title: "LEGAL ENTITY",
      width: 200,
      render: (record: any) => (
        <div className="text-gray-700 truncate flex items-center">
          <span>
            {record?.isLinked ? (
              <MdOutlineCheckCircle color="#15803d" />
            ) : (
              <MdOutlinePending color="#dc2626" />
            )}
          </span>
          <span className="mx-1">{record?.company || "-"}</span>
        </div>
      ),
    },
    {
      title: "LINKED COMPANY",
      width: 200,
      render: (record: any) => (
        <div className="text-gray-700 truncate">
          {record?.firm?.name || "-"}
        </div>
      ),
    },
    {
      title: "COST CENTER",
      width: 200,
      render: (record: any) => (
        <div className="text-gray-700 truncate">
          {record?.costCenter || "-"}
        </div>
      ),
    },
    {
      title: "SUB COST CENTER",
      width: 200,
      render: (record: any) => (
        <div className="text-gray-700 truncate">
          {record?.subCostCenter || "-"}
        </div>
      ),
    },
    {
      title: "BUSINESS SEGMENT HEAD 1",
      width: 200,
      render: (record: any) => (
        <div className="text-gray-700 truncate">
          {record?.businessHead1 || "-"}
        </div>
      ),
    },
    {
      title: "BUSINESS SEGMENT HEAD 2",
      width: 200,
      render: (record: any) => (
        <div className="text-gray-700 truncate">
          {record?.businessHead2 || "-"}
        </div>
      ),
    },

    {
      title: "COUNTRY",
      width: 120,
      render: (record: any) => (
        <div className="flex items-center text-gray-700">
          <span>{record?.country || "-"}</span>
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setCountryModal(true);
            }}
            className="flex justify-center items-center text-gray-700 px-2 py-1 cursor-pointer"
          >
            <FiEdit />
          </button>
        </div>
      ),
    },
    {
      title: "SCOPE",
      width: 120,
      render: (record: any) => (
        <div className="flex items-center text-gray-700">
          <span>{record?.aprScope || "-"}</span>
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setScopeModal(true);
            }}
            className="flex justify-center items-center text-gray-700 px-2 py-1 cursor-pointer"
          >
            <FiEdit />
          </button>
        </div>
      ),
    },

    {
      title: "SIGNATURE",
      width: 150,
      render: (record: any) => (
        <div className="flex items-center justify-between px-2">
          {record?.signature ? (
            <img
              src={record?.signature}
              alt="signature"
              className="w-12 h-12"
            />
          ) : (
            <span className="text-gray-500">No Signature</span>
          )}
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setUploadModal(true);
            }}
            className="flex justify-center items-center text-gray-700 border rounded-md px-2 py-1 bg-gray-100 hover:bg-gray-200 cursor-pointer"
          >
            <Signature color={"#424242"} size={12} />
          </button>
        </div>
      ),
    },

    {
      title: "ACCESS LEVEL",
      width: 200,
      render: (record: any) => (
        <div className="text-gray-700 truncate">
          {record?.accessLevel ? `Level: ${record?.accessLevel}` : "-"}
        </div>
      ),
    },

    {
      title: "APPROVER",
      width: 140,
      render: (record: any) => (
        <div className="text-gray-700 truncate">
          {record?.canApprove ? "Yes @ Level " : "No"}
          {record?.canApprove ? record?.aprLevel : ""}
        </div>
      ),
    },

    {
      title: "ACTION",
      width: 200,
      render: (record: any) => (
        <div className="flex items-center">
          <div className="flex mr-2">

            <button
              onClick={() => {
                setSelected({
                  ...record,
                });
                setEditModal(true);
              }}
              className="flex justify-center items-center text-gray-700 border rounded-md px-2 py-1 bg-yellow-100 hover:bg-yellow-200 cursor-pointer"
            >
              <FiEdit />
              <span className="ml-1">Edit</span>
            </button>
          </div>
          <div className="flex">
            {record?.canApprove ? (
              <button
                onClick={() => {
                  setSelected({
                    ...record,
                  });
                  setUpdateModal(true);
                }}
                className="flex justify-center items-center text-gray-700 border rounded-md px-2 py-1 bg-yellow-100 hover:bg-yellow-200 cursor-pointer"
              >
                <FiEdit />
                <span className="ml-1">Change Level</span>
              </button>
            ) : (
              <button
                onClick={() => {
                  setSelected({
                    ...record,
                  });
                  setApproverModal(true);
                }}
                className="flex justify-center items-center text-gray-700 border rounded-md px-2 py-1 bg-blue-100 hover:bg-blue-200 cursor-pointer"
              >
                <FiEdit />
                <span className="ml-1">Make Approver</span>
              </button>
            )}
          </div>
        </div>
      ),
      fixed: "right",
    },
  ];

  useEffect(() => {
    setPagination({ ...pagination, total: users?.total });
  }, [users]);

  return (
    <Manage
      title={"Inactive Users"}
      subtitle={"All"}
      description={"List of all users"}
      actions={
        <div className="flex">
          <div className="flex">
            <Form layout="inline" form={form}>
              <Form.Item name="name">
                <Search
                  placeholder="Search by name"
                  className="rounded-none"
                  allowClear
                  onSearch={(e: any) => {
                    setFilters({ ...filters, name: e });
                  }}
                />
              </Form.Item>
            </Form>
            <Button
              className="mr-2 -ml-4 focus:outline-none hover:bg-red-100 rounded-none"
              onClick={() => {
                clearAllFilters();
              }}
            >
              <RiFilterOffLine color="gray" />
            </Button>
          </div>
          <UploadWrapper refetch={refetch} />
          <CreateWrapper refetch={refetch} />
        </div>
      }
    >
      <div className="grid gap-x-0 grid-cols-12">
        <div className="col-span-12 sm:col-span-12 md:col-span-12">
          <Table
            size="small"
            dataSource={users?.records}
            columns={columns}
            scroll={{ y: 660, x: 0 }}
            rowKey="_id"
            style={{ fontSize: "12px" }}
            bordered
            pagination={{
              current: pagination?.page,
              pageSize: pagination?.limit,
              total: pagination?.total,
            }}
            onChange={(e: any) => handlePageChange(e)}
            loading={isLoading}
          />

          {updateModal && (
            <UpdateUser
              selected={selected}
              isVisible={updateModal}
              setUpdateModal={setUpdateModal}
              refetch={refetch}
            />
          )}

          {approverModal && (
            <UpdateApr
              selected={selected}
              isVisible={approverModal}
              setVisible={setApproverModal}
              refetch={refetch}
            />
          )}

          {countryModal && (
            <UpdateCountry
              selected={selected}
              isVisible={countryModal}
              setVisible={setCountryModal}
              refetch={refetch}
            />
          )}

          {scopeModal && (
            <UpdateScope
              selected={selected}
              isVisible={scopeModal}
              setVisible={setScopeModal}
              refetch={refetch}
            />
          )}

          {editModal && (
            <EditUser
              selected={selected}
              isVisible={editModal}
              setVisible={setEditModal}
              refetch={refetch}
            />
          )}

          {deleteModal && (
            <DeleteUser
              selected={selected}
              isVisible={deleteModal}
              setVisible={setDeleteModal}
              refetch={refetch}
            />
          )}


          {uploadModal && (
            <UploadSign
              isVisible={uploadModal}
              setVisible={setUploadModal}
              selected={selected}
            />
          )}
        </div>
      </div>
    </Manage>
  );
}
